import React, { useState } from "react";
import { Helmet } from "react-helmet-async";

import Subheader from "../../components/UI/Subheader/Subheader";
import CollaboratorList from "../../components/Collaborator/CollaboratorList/CollaboratorList";

function CollaboratorListScreen() {
  window.history.replaceState({}, document.title);

  const [updatedAt, setUpdatedAt] = useState(undefined);
  const setSubheaderUpdatedAt = (date) => {
    setUpdatedAt(date);
  };

  return (
    <>
      <Helmet>
        <title>Colaboradores</title>
      </Helmet>
      <Subheader title="Colaboradores" updatedAt={updatedAt} />

      <CollaboratorList setSubheaderUpdatedAt={setSubheaderUpdatedAt} />
    </>
  );
}

export default CollaboratorListScreen;
